module.exports = [{
      plugin: require('/Volumes/LJRDEV/dev/spectreapp/src/Spectre/AppBundle/Resources/ReactPro/node_modules/gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":"https://b43219471a104d25bb0828715787cb50@sentry.io/1429351","environment":"production","enabled":true},
    },{
      plugin: require('/Volumes/LJRDEV/dev/spectreapp/src/Spectre/AppBundle/Resources/ReactPro/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
